import grid1 from '../../assets/blog/grid1.svg'
import grid2 from '../../assets/blog/grid2.png'
import grid3 from '../../assets/blog/grid3.png'
import grid4 from '../../assets/blog/grid4.png'
import grid5 from '../../assets/blog/grid5.svg'
import grid6 from '../../assets/blog/grid6.svg'
import grid7 from '../../assets/blog/grod7.svg'
import grid8 from '../../assets/blog/grid8.svg'
import grid9 from '../../assets/blog/grid9.svg'
import grid10 from '../../assets/blog/grid10.svg'
import grid11 from '../../assets/blog/grid11.svg'
import grid12 from '../../assets/blog/geid12.svg'
import grid14 from '../../assets/blog/grid14.svg'
import grid15 from '../../assets/blog/grid15.svg'
import grid16 from '../../assets/blog/grid16.svg'

export const BlogData = [
    {
        img: `${grid1}`,
        title: 'Behind Gumroad’s New Design System',
        desc: 'The story of our site-wide redesign and web tech and accessibility wins.',
        date: 'May 9, 2022'
    },
    {
        img: `${grid2}`,
        title: `How to use Gumroad's free email marketing to build an audience & generate sales`,
        desc: `Learn how creators can build an audience and generate more sales using Gumroad's built-in, free email marketing tool.`,
        date: 'Feburary 16, 2022'
    },
    {
        img: `${grid3}`,
        title: '39 Spark AR patches & templates to create Instagram filters',
        desc: `Create Instagram filters and augmented reality (AR) games with these Spark AR Studio patches and templates, available to download on Gumroad.`,
        date: 'February 16, 2022'
    },
    {
        img: `${grid4}`,
        title: '35 Lightroom presets to level up your photography',
        desc: `Get the shot you've always wanted: popular Lightroom presets from Gumroad to enhance your photos and streamline your editing process.`,
        date: 'January 4, 2022'
    },
    {
        img: `${grid5}`,
        title: 'Top 36 Blender add-ons, tutorials & assets for 3D animators',
        desc: 'A collection of top Blender tutorials, modeling, add-ons, textures and more assets from digital artists on Gumroad (free and premium downloads).',
        date: 'November 15, 2021'
    },
    {
        img: `${grid6}`,
        title: 'How to create and sell eBooks: all you need to know',
        desc: `Learn how to create an eBook and sell it online. In this article, we cover all you need to know, from the basics to getting paid, and more!`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid7}`,
        title: '9 digital product ideas (with successful examples)',
        desc: `If you're not sure what digital products to sell, we cover all you need to know from digital product ideas to selling them, and much more in this comprehensive article.`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid8}`,
        title: '38 notion templates to organize your life',
        desc: `A collection of top Notion Templates to boost your productivity so you can get more out of your workday.`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid9}`,
        title: 'Top 38 UI kits for designing web & mobile apps',
        desc: `The best UI kits, designed for sketching, prototyping & sharing. Download the top web & mobile design resources for Figma, Photoshop, Sketch & more!`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid10}`,
        title: '102 creators who’ve each earned over $100,000 share their single best tip for aspiring creators',
        desc: `We asked 102 creators who've earned over $100,000 each from selling digital products what their best tip was for aspiring creators. Read them all in this article.`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid11}`,
        title: 'Follow this guide to sell more as a Gumroad creator',
        desc: `This article presents practical tips for leveraging Gumroad so you can sell more products as a creator and digital entrepreneur.`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid12}`,
        title: 'How to sell online memberships: all you need to know',
        desc: `Since 2010, the Creator Economy has been powered by a wave of software and internet platforms making it easy to buy and sell products and services online.`,
        date: 'December 6, 2021'
    },
    {
        img: `${grid1}`,
        title: 'Top 37 Procreate brushes for artists on Gumroad',
        desc: `Procreate is an absolute powerhouse of an app, but even though there's a decent range of brushes available in the app itself, sometimes you just need more.`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid14}`,
        title: 'Five ways digital artists make money online',
        desc:   `Making money as a Digital Artist is a dream for many artists. Read this article to learn the 5 actionable ways digital artists can make money online.`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid15}`,
        title: '53 free Procreate brushes you can download on Gumroad',
        desc: `Download 53 Procreate Brushes from top Gumroad creators and take your illustration art to the next level!`,
        date: 'November 24, 2021'
    },
    {
        img: `${grid16}`,
        title: 'How to earn a side income selling digital products',
        desc: `A whole new world of potential revenue streams await you and getting started is easier than you think. In fact, your greatest monetary gains may be the easiest you’ve ever made.`,
        date: 'December 15, 2021'
    },
]